import React from 'react';

import {
    Box,
    Grid,
    Typography,
    Paper,
    Stack,
    Chip
} from '@mui/material';

import { lightBlue, blueGrey } from '@mui/material/colors';

import DiscountTwoToneIcon from '@mui/icons-material/DiscountTwoTone';

import { motion } from 'framer-motion';

import CleaningCartCard from './services/CleaningCartCard';
import TumblerCleanerCard from './services/TumblerCleanerCard';
import MarketPlaceCard from './services/MarketPlaceCard';
import DaclairPlatformCard from './services/DaclairPlatformCard';
import EnterpriseCard from './services/EnterpriseCard';

// Framer Motion 애니메이션 Variants
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.2 } // 카드들이 0.2초 간격으로 나타납니다.
    }
};



export default function ServiceSection(props){
    return (
        <Box sx={{ my: 2, padding:'48px 0px 108px' }}>
            {/* 서비스 카드 그리드 */}
            <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}>
            <Grid container spacing={2}
                direction="row"
                justifyContent="center"
                sx={{ width:'100%'}}
                alignItems="center">
                <Grid size={{
                xs : 12,
                sm : 12,
                md : 12
                }}>
                <Typography
                    sx={{
                    fontFamily: "NotoSansKR",
                    fontWeight:900,
                    textAlign:'center',
                    fontSize:{xs:'24px',md:'42px'},
                    mb:'48px',
                    color:blueGrey[800]
                    }}>
                    사람과 환경을 우선으로 생각합니다
                </Typography>
                </Grid>
                <CleaningCartCard />
                <TumblerCleanerCard />
                <MarketPlaceCard />
                <DaclairPlatformCard />
                <EnterpriseCard />
            </Grid>
          </Box>
        </Box>
    );
}
